// extracted by mini-css-extract-plugin
export var productImage = "_mm-0";